import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import clsx from 'clsx'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Button from '../Button'
import { TextField as MuiTextField } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import Switch from '@material-ui/core/Switch'
import Slider from '@material-ui/core/Slider'
import Checkbox from '@material-ui/core/Checkbox'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormHelperText from '@material-ui/core/FormHelperText'

export const TextField = (props) => {
  const {
    name,
    value,
    label,
    link,
    component,
    currency,
    suffix,
    decimal,
    onChange,
    onClick,
    content,
    className,
    actions,
    style,
    required,
    autoFocus,
    margin,
    width,
    light,
    type,
    id,
    disabled,
    size,
    textFieldMargin,
    textFieldVariant,
    textFieldType,
    multiline,
    rows,
    rowsMax,
    inputProps,
    helperText,
    FormHelperTextProps,
    localClasses,
    options,
    map,
    multiple,
    MenuProps,
    autoWidth,
    labelWidth,
    checked,
    marks,
    step,
    min,
    max,
    valueLabelDisplay,
    defaultValue,
    defaultChecked,
    icon,
    color,
    labels,
    placement,
    legend,
    formPadding,
    formMargin,
    ...rest
  } = props

  return type === 'text' ? (
    <MuiTextField
      id={id}
      label={label}
      name={name}
      onChange={onChange}
      style={
        style
          ? style
          : {
              margin: margin,
              width: width
            }
      }
      className={
        light
          ? 'text-field-light-style'
          : link
          ? 'link-text-field-style'
          : 'text-field-style'
      }
      value={value ? value : ''}
      variant={textFieldVariant}
      margin={textFieldMargin}
      type={textFieldType}
      required={required}
      disabled={disabled}
      autoFocus={autoFocus}
      InputProps={
        (currency || decimal) && component
          ? {
              inputComponent: component
            }
          : inputProps
          ? inputProps
          : null
      }
      inputProps={{ suffix: suffix }}
      size={size}
      multiline={multiline}
      rows={rows}
      rowsMax={rowsMax}
      helperText={helperText}
      FormHelperTextProps={FormHelperTextProps}
      classes={localClasses}
      {...rest}
    />
  ) : type === 'select' ? (
    <FormControl
      id={id}
      variant={textFieldVariant}
      margin={textFieldMargin}
      className={light ? 'text-field-light-style' : 'text-field-style'}
      required={required}
      style={
        style
          ? style
          : {
              margin: margin,
              width: width
            }
      }>
      <InputLabel className="text-color" htmlFor={name}>
        {label}
      </InputLabel>
      <Select
        native
        label={label}
        labelId={id}
        value={value ? value : ''}
        onChange={onChange}
        multiple={multiple}
        MenuProps={MenuProps}
        autoWidth={autoWidth}
        labelWidth={labelWidth}
        inputProps={
          inputProps
            ? inputProps
            : {
                name: name
              }
        }>
        <option aria-label="None" value="" />
        {map
          ? options.map((i) => (
              <option key={uuid()} value={i.v}>
                {i.o}
              </option>
            ))
          : options &&
            !map &&
            options.map((o) => {
              return o.name ? (
                <optgroup key={uuid()} label={o.name}>
                  {o.options &&
                    o.options.map((oo) => {
                      return (
                        <option key={uuid()} value={oo.v}>
                          {oo.o}
                        </option>
                      )
                    })}
                </optgroup>
              ) : (
                <option key={uuid()} value={o.v}>
                  {o.o}
                </option>
              )
            })}
      </Select>
    </FormControl>
  ) : type === 'switch' ? (
    labels ? (
      <FormControl component="fieldset">
        <h4 style={{ padding: 0, margin: 0 }} component="legend">
          {legend}
        </h4>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                id={id}
                checked={checked}
                onChange={onChange}
                onClick={onClick}
                name={name}
                value={value}
              />
            }
            label={label}
          />
        </FormGroup>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    ) : (
      <Switch
        id={id}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        name={name}
        style={style}
        value={value}
        color={color}
      />
    )
  ) : type === 'slider' ? (
    <Slider
      onChange={onChange(name)}
      name={name}
      defaultValue={defaultValue}
      aria-labelledby="discrete-slider-restrict"
      step={step}
      valueLabelDisplay={valueLabelDisplay}
      value={value}
      marks={marks}
      min={min}
      max={max}
      aria-label={label}
    />
  ) : type === 'checkbox' ? (
    labels ? (
      <FormControl component="fieldset">
        <h4 style={{ padding: 0, margin: 0 }} component="legend">
          {legend}
        </h4>
        <FormGroup aria-label="position" row>
          <FormControlLabel
            value={value}
            control={
              <Checkbox
                id={id}
                name={name}
                onChange={onChange}
                defaultChecked={defaultChecked}
                color="default"
                inputProps={{ 'aria-label': 'checkbox with default color' }}
                required={required}
                size={size}
                icon={icon}
                style={
                  color === 'red'
                    ? {
                        color: '#e3342f'
                      }
                    : color === 'blue'
                    ? { color: '#2f7ae3' }
                    : style
                }
              />
            }
            label={label}
            labelPlacement={placement}
          />
        </FormGroup>
      </FormControl>
    ) : (
      <Checkbox
        id={id}
        name={name}
        onChange={onChange}
        defaultChecked={defaultChecked}
        color="default"
        inputProps={{ 'aria-label': 'checkbox with default color' }}
        required={required}
        size={size}
        icon={icon}
        style={
          color === 'red'
            ? {
                color: '#e3342f'
              }
            : color === 'blue'
            ? { color: '#2f7ae3' }
            : style
        }
      />
    )
  ) : type === 'radio' ? (
    labels ? (
      value && (
        <FormControl
          component="fieldset"
          aria-labelledby="radio-fieldset"
          style={{
            width: '-webkit-fill-available',
            padding: formPadding,
            margin: formMargin
          }}>
          {legend && (
            <h4
              aria-labelledby="radio-legend"
              style={{ padding: 0, margin: 0 }}
              component="legend">
              {legend}
            </h4>
          )}
          <div
            style={{
              display:
                placement === 'bottom' || placement === 'top'
                  ? 'flex'
                  : 'unset',
              justifyContent: 'space-between'
            }}>
            {value &&
              value.map((v) => {
                return (
                  <RadioGroup
                    key={uuid()}
                    row
                    aria-label={id}
                    aria-labelledby="radio-group"
                    defaultValue={defaultValue}>
                    <FormControlLabel
                      label={v.label}
                      labelPlacement={placement}
                      control={
                        <Radio
                          id={id}
                          checked={checked === v.value}
                          onChange={onChange}
                          value={v.value}
                          color={color}
                          name={name}
                          inputProps={{ 'aria-label': id }}
                          size={size}
                          required={required}
                          disabled={disabled}
                        />
                      }
                    />
                  </RadioGroup>
                )
              })}
          </div>
        </FormControl>
      )
    ) : (
      value.map((v) => {
        return (
          <Radio
            id={id}
            key={uuid()}
            checked={checked === v}
            onChange={onChange}
            value={v}
            color={color}
            name={name}
            inputProps={{ 'aria-label': id }}
            size={size}
            required={required}
            disabled={disabled}
          />
        )
      })
    )
  ) : (
    ''
  )
}

TextField.propTypes = {
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  light: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  component: PropTypes.func,
  currency: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  type: PropTypes.oneOf([
    'text',
    'select',
    'switch',
    'slider',
    'checkbox',
    'radio'
  ]).isRequired,
  margin: PropTypes.string,
  width: PropTypes.string,
  required: PropTypes.bool,
  autoFocus: PropTypes.bool,
  error: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'small']),

  // TextField PropTypes
  textFieldMargin: PropTypes.oneOf(['dense', 'normal', 'none']),
  textFieldVariant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  multiline: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  suffix: PropTypes.string,
  link: PropTypes.bool,
  textFieldType: PropTypes.oneOf([
    'button',
    'checkbox',
    'color',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'image',
    'month',
    'number',
    'password',
    'radio',
    'range',
    'reset',
    'search',
    'submit',
    'tel',
    'text',
    'time',
    'url',
    'week'
  ]),

  // Select PropTypes
  inputProps: PropTypes.object,
  helperText: PropTypes.node,
  FormHelperTextProps: PropTypes.object,
  localClasses: PropTypes.object,
  multiple: PropTypes.bool,
  MenuProps: PropTypes.object,
  autoWidth: PropTypes.bool,
  labelWidth: PropTypes.number,
  map: PropTypes.bool,

  // Switch PropTypes
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  ios: PropTypes.bool,

  // Slider PropTypes
  marks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  valueLabelDisplay: PropTypes.oneOf(['on', 'off', 'auto']),
  defaultValue: PropTypes.number,

  // Checkbox PropTypes
  defaultChecked: PropTypes.bool,
  icon: PropTypes.node,
  color: PropTypes.string,

  // Radio PropTypes
  labels: PropTypes.bool,
  placement: PropTypes.oneOf(['start', 'end', 'top', 'bottom']),
  legend: PropTypes.string,
  formPadding: PropTypes.string,
  formMargin: PropTypes.string
}

TextField.defaultProps = {
  margin: '6px',
  width: '256px',
  size: 'small',
  textFieldMargin: 'dense',
  textFieldVariant: 'outlined',
  valueLabelDisplay: 'auto',
  placement: 'end',
  formPadding: '0px',
  formMargin: '0px'
}

TextField.displayName = 'tx'

export default TextField
